import  React from 'react';
import * as H from 'history';
import { ClaimModel } from '../../models/ClaimModel';
import { ISupportSpinner } from '../../shared/Ajax';
import { TermsPage } from './TermsPage';
import { BusinessPage } from './BusinessPage';
import { PersonalisePage } from './PersonalisePage';
import { PreparePage } from './PreparePage';
import Button from 'react-bootstrap/Button'
import { PrintBackButtons } from './controls/PrintBackButtons';
import { Option } from '../../shared/fields/Options';
import { Consultant } from '../../models/Consultant';
import { ReviewPage } from './ReviewPage';

export interface PreviewPageProps {
    history: H.History
    model: ClaimModel
    markets: Option<string>[]
    onChange: { (changes: Partial<ClaimModel>): any }
    onSubmit: { (autoClaimNumber: string): any }
    onPrint?: { (e: React.MouseEvent): any }
    print?: boolean
    consultants: Consultant[]
    addressCountries: Option<string>[]
    lowRiskMarkets: string[]
}

export interface PreviewPageState {
    loading: boolean
}

export class ApplicationForm1PreviewPage extends React.Component<PreviewPageProps, PreviewPageState> implements ISupportSpinner {

    constructor(props: PreviewPageProps) {
        super(props);
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        if (this.props.print) {
            window.print();
        }
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback);
    }

    print = (e: React.MouseEvent) => {
        if (this.props.onPrint)
            this.props.onPrint(e);
        else
            window.print();
    }

    back = () => {
        this.props.history.goBack();
    }

    render() {
        return <div>
            <PrintBackButtons onBack={this.back} onPrint={this.print} printLabel={this.props.onPrint ? "Print to pdf" : "Print"} />
            <div className="form-content-preview">
                <div><span><strong>Application ID: </strong></span><span>{this.props.model.autoClaimNumber}</span></div>
                <div><span><strong>Applicant Name: </strong></span><span>{this.props.model.registeredNameLocal || this.props.model.registeredName}</span></div>
                <div><span><strong>Grant Year: </strong></span><span>{this.props.model.claimYear}</span></div>
            </div>
            {<TermsPage {...this.props} preview={true} />}
            <BusinessPage {...this.props} preview={true} />
            <PersonalisePage {...this.props} preview={true} />
            <PreparePage {...this.props} preview={true} />
            <ReviewPage {...this.props} preview={true} />
            <PrintBackButtons onBack={this.back} onPrint={this.print} printLabel={this.props.onPrint ? "Print to pdf" : "Print"} />
        </div>
    }
}